<template>
  <div class="table-school-fees">
    <h4 class="title-section">{{ title }}</h4>
    <table v-for="valueFeeData,keyFeeData,indexFeeData in tableSchoolFeesData" :key="'feeData-' + indexFeeData">
        <tr>
            <th colspan="12" class="background-pink-color">{{keyFeeData}}</th>
            <th rowspan="3" class="background-pink-color color-red">Ngày đóng học phí</th>
            <th rowspan="3" class="background-pink-color color-red">Tình trạng học phí</th>
        </tr>
        <tr>
            <td v-for="valuemonthDetail, keymonthDetail, indexMonth in valueFeeData" :key="'month-'+indexMonth">{{keymonthDetail}}</td>
        </tr>
        <tr>
            <td v-for="valuemonthDetail, keymonthDetail, indexMonth in valueFeeData" :key="'month-'+indexMonth" >{{valuemonthDetail != '' && valuemonthDetail['Ngày'
              ] != '' ? formatDate(valuemonthDetail['Ngày']) : '' }}</td>
        </tr>
        <tr>
            <td v-for="valuemonthDetail, keymonthDetail, indexMonth in valueFeeData" :key="'month-'+indexMonth">{{valuemonthDetail['Trạng thái'
              ] != '' ? valuemonthDetail['Trạng thái'] : '' }}</td>
            <td>{{fee[keyFeeData] != '' ? fee[keyFeeData]['Học phí'] : 'Chưa xác nhận'}}</td>
            <td>{{fee[keyFeeData] != '' && fee[keyFeeData]['Ngày đóng học phí'] != '' ? formatDate(fee[keyFeeData]['Ngày đóng học phí']) : 'Chưa xác nhận'}}</td>
        </tr>
    </table>
    <br>
    <div>
      <h4>Các tháng chưa đóng học phí: {{this.unpaidSchoolFeeData}}</h4>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableSchoolFees',
  props: ['tableSchoolFeesData', 'title', 'unpaidSchoolFeeData'],
  components: {},
  data() {
    return {
      fee:null
    }
  },
  watch: {
  },
  created() {
    this.makeTable()
    // this.loopSortByKey()
  },
  methods: {
    makeTable(){
      if (this.tableSchoolFeesData != ''){
        let ob = {}
        ob.unpaid = this.unpaidSchoolFeeData;
        // let self = this
        Object.entries(this.tableSchoolFeesData).forEach(key => {
          ob[key[0]] = { 
            'Học phí' : key[1]['Học phí'] !== undefined ? key[1]['Học phí']: '',
            'Ngày đóng học phí' : key[1]['Ngày đóng học phí'] !== undefined ? key[1]['Ngày đóng học phí'] : ''
          }
          key[1]['Học phí'] !== undefined ? delete key[1]['Học phí'] : ''
          key[1]['Ngày đóng học phí'] !== undefined ? delete key[1]['Ngày đóng học phí'] : ''
        })
        this.fee = ob
      }
    },
    formatDate(dateString){
        let date = new Date(dateString);
        var month = date.getUTCMonth() + 1; //months from 1-12
        var day = date.getUTCDate();
        // var year = date.getUTCFullYear();
        // let newdate = day + "/" + month + "/" + year;
        let newdate = day + "/" + month;
        return newdate
    },
  }
}
</script>

<style>
</style>